<template>
  <div class="driver-info new"
       :class="{'over-flow-hidden': overflowHidden}">
    <!-- <ucar-title type="confirmBack"
                text="尚未完成提交，是否退出报名"
                ok-text="确定退出"
                v-if="needLogout">{{title}}</ucar-title> -->
    <ucar-title toApp="/"
                >人证上传</ucar-title>
    <div class="photo-info">
      <template>
        <div v-if="carOnlinePermitRequire">
          <div class="photo-group-title">网约车驾驶员证</div>
          <div class="photo-group">
            <ucar-upload-img 
              v-bind="photoBaseData.networkLicense"       
              v-model="photoInfo.carOnlinePermitImg"
              :error="photoError.networkLicense"
              @uploadFinish="autoSetInfoAndPhotoInfo">
            </ucar-upload-img>
          </div>
        </div>
        <!-- <div v-if="carOnlineTransportRequire">
          <div class="photo-group-title">网络预约出租汽车运输证</div>
          <div class="photo-group">
            <ucar-upload-img
              v-bind="photoBaseData.networkCarTransportLiscense"
              v-model="photoInfo.carOnlineTransportImg"
              :error="photoError.networkCarTransportLiscense"
              @uploadFinish="autoSetInfoAndPhotoInfo"
            ></ucar-upload-img>
          </div>
        </div> -->
      </template>
    </div>
    <ucar-section>
      <div class="row row-info" v-if="carOnlinePermitRequire">
        <label>驾驶员证有效期</label>
        <ucar-date-select v-model="info.carOnlinePermitValidDate"
                          :start-date="new Date()"
                          :end-date="new Date((new Date()).getFullYear() + 20, (new Date()).getMonth(), (new Date()).getDate())"></ucar-date-select>
      </div>
      <!-- <div class="row" v-if="carOnlineTransportRequire">
          <label>运输证有效期</label>
          <ucar-date-select v-model="info.carOnlineTransportValidDate"
                          :start-date="new Date()"
                          :end-date="new Date((new Date()).getFullYear() + 20, (new Date()).getMonth(), (new Date()).getDate())"></ucar-date-select>
      </div> -->
    </ucar-section>
    <div class="footer">
      <button type="button"
              class="btn-submit app-btn-submit"
              :class="{'app-btn-submit-enable': enableSubmit || redirectEnable}"
              @click="submit"
            >
        提交
      </button>
    </div>
    <error-dialog v-if="showErrorDialog"
                  @close="closeErrorDialog"
                  :groups="rejectErrors"></error-dialog>
  </div>
</template>

<script>
import ucarStorage from '../../utils/storage'
import{popView}from "../../utils/jsBridge/jsBridge.js";
import ErrorDialog from '../../components/error-dialog'
import ProtocolDialog from '../../components/protocol-dialog'
import valid from '../../utils/valid-check'
import preload from '../../utils/preload'
import { PhotoBaseData, resetDriverLicense } from '../../utils/constants'
import { transformCities, copyTargetProperty } from '../../utils/transform'
import { credentialsUpload, appCredentialsInfo, gaeaQuery } from '../../api'
export default {
  components: {
    ErrorDialog,
    ProtocolDialog,
  },
  data () {
    return {
      expires: '',
      carOnlinePermitRequire: 0,
      carOnlineTransportRequire: 0,
      body: {},
      redirectEnable: false,
      mode: 'normal',
      needLogout: true,
      rejectedCount: 0,
      showErrorDialog: false,
      rejectErrors: [],
      // 驾驶证OCR缓存对象
      driverLicenseOcrInfo: {
        ...resetDriverLicense
      },
      info: {
        carOnlinePermitValidDate: '',
        carOnlineTransportValidDate: '',
      },
      photoInfo: {
        carOnlinePermitImg: '',
        carOnlineTransportImg: '',
      },
      photoError: {
        idCardNo: '',
        idCardBack: '',
        license: '',
        // secondLicense: '',
        networkLicense: '',
        acidDetection: ''
      },
      photoBaseData: PhotoBaseData,
      baseData: {
        driverLicenseTypes: [
          {
            name: 'C2',
            value: 7
          },
          {
            name: 'C1',
            value: 6
          },
          {
            name: 'B2',
            value: 5
          },
          {
            name: 'B1',
            value: 4
          },
          {
            name: 'A3',
            value: 3
          },
          {
            name: 'A2',
            value: 2
          },
          {
            name: 'A1',
            value: 1
          },
        ],
        houseHoldCityList: [],
        tempHouseHoldCityList: [],
        serviceCityList: [],
        channelOptions: []
      },
      overflowHidden: false,
      // 识别结果 区域 姓名输入框聚焦
      infoNameInpOnFoucs: false,
    }
  },
  computed: {
    cityOptions () {
      return transformCities(this.vuexServiceCities)
    },
    readIdentifyComplete () {
      return this.info.idCardNo && this.info.name
    },
    // needNetworkLicense() {
    //   return this.vuexCompanyId ? this.vuexCurrentCity.needCompanyNetworkLicense : this.vuexCurrentCity.needNetworkLicense
    // },
    enableSubmit () {
      console.log('this.info',this.info)
      const errorInfo =
      // || valid.notEmpty(this.info.carOnlinePermitValidDate, '驾网约车驶员证有效期')
      // valid.notEmpty(this.info.carOnlineTransportValidDate, '网络预约出租汽车运输证有效期')
        valid.notEmpty(this.photoInfo.carOnlinePermitImg, '网约车驾驶员证') &&
        valid.notEmpty(this.photoInfo.carOnlineTransportImg, '网络预约出租汽车运输证') 
        
      return errorInfo === ''
    },
    ocrComplete(){
      return (this.info.name || this.info.idCardNo) && (this.info.driverLicenseName || this.info.driverLicenseNo )
    }
  },
  watch: {
    'info.driverLicenseFileNo' (val) {
      this.info.driverLicenseFileNo = val.replace(/[^A-Za-z\d]/g, '').toUpperCase()
    },
    'info.onLineDriverLicenseNo' (val) {
      this.info.onLineDriverLicenseNo = val.replace(/[^A-Za-z\d]/g, '').toUpperCase()
    }
  },
  methods: {
    autoSetInfoAndPhotoInfo (val) {
      console.log('val?',val)
      if(ucarStorage.getStorage('netPhotoInfo')){
          ucarStorage.setStorage('netPhotoInfo',Object.assign(ucarStorage.getStorage('netPhotoInfo'),this.photoInfo),this.expires)
      }
      if(!ucarStorage.getStorage('netPhotoInfo')){
        ucarStorage.setStorage('netPhotoInfo',this.photoInfo,this.expires)
      }
    },
    arrange () {
      if(ucarStorage.getStorage('netPhotoInfo')){
        console.log("ucarStorage.getStorage('netPhotoInfo')",ucarStorage.getStorage('netPhotoInfo'))
        this.photoInfo=ucarStorage.getStorage('netPhotoInfo')
      }
      this.body = Object.assign(this.info,this.photoInfo)
      this.body.enlistId = this.$route.query.enlistId
    },

    async submit () {
      this.arrange()
      console.log('arrange?this.body',this.body)
      const submitRes = await credentialsUpload(this.body)
      if (submitRes.code === 1) {
        console.log('成功返回')
        popView()
      }
    },

    async getInfo () {
      const res = await appCredentialsInfo({enlistId:this.$route.query.enlistId})
      console.log('getInfo res',res)
      this.carOnlinePermitRequire = res.carOnlinePermitRequire
      this.carOnlineTransportRequire = res.carOnlineTransportRequire
      if(res.status===3){
        this.$alert({
            type: 'confirm',
            dsc: `${res.reason}`,
            okText: '我知道了',
            center: true,
        })
        this.info.carOnlinePermitValidDate = res.carOnlinePermitValidDate
        this.info.carOnlineTransportValidDate = res.carOnlineTransportValidDate
        this.photoInfo.carOnlinePermitImg = res.carOnlinePermitImg
        this.photoInfo.carOnlineTransportImg = res.carOnlineTransportImg
      }
    },
    // getBaseData () {
    //   this.$loading.show()
    //   preload([
    //     PhotoBaseData.idCard.defaultImg,
    //     PhotoBaseData.idCardBack.defaultImg,
    //     PhotoBaseData.license.defaultImg,
    //     // PhotoBaseData.secondLicense.defaultImg,
    //     PhotoBaseData.networkLicense.defaultImg,
    //     PhotoBaseData.acidCheckLicense.defaultImg
    //   ]).then(() => {
    //     return Promise.all([
    //       getRecruitSources(),
    //     ])
    //   }).then(res => {
    //     this.baseData.channelOptions = res[0].recruitSourceList.map(item => {
    //       return {
    //         name: item.recruitSource,
    //         value: item.recruitSourceId
    //       }
    //     })
    //     if (this.vuexDriverInfo) {
    //       copyTargetProperty(this.info, this.vuexDriverInfo)
    //       copyTargetProperty(this.photoInfo, this.vuexDriverInfo)
    //       // 如果是从缓存中读取，需要对当前缓存中的信息做判断如果上次提交的OCR识别结果为完成，则需将当前缓存的提交信息反向映射为OCR身份证/驾驶证缓存信息，以便在提交时完成对比
    //       if (this.vuexDriverInfo.idCardOcr === 1) copyTargetProperty(this.idCardOcrInfo, this.info)
    //       if (this.vuexDriverInfo.driverLicenseOcr === 1) copyTargetProperty(this.driverLicenseOcrInfo, this.info)
    //       this.rejectedCount = this.vuexDriverInfo.driverRejectedCount
    //       this.forbidenChooseServiceCity = this.vuexDriverInfo.vehicleBindable === 1 // 如果次申请单可以绑定车辆，即代表次申请单进入过人工审核状态
    //       if (this.vuexDriverInfo.serviceCityId) {
    //         const currentCity = this.vuexServiceCities.find(item => item.cityId === this.vuexDriverInfo.serviceCityId)
    //         this.setVuexCurrentCity({ ...currentCity, id: this.vuexDriverInfo.serviceCityId })
    //       }
    //     }
    //     this.$loading.hidden()
    //   })
    // },
    closeErrorDialog () {
      this.showErrorDialog = false
      this.rejectErrors = []
    },
  },
  async mounted () {
    const timeRes = await gaeaQuery({key: 'enlistCache'})
    const expires = timeRes.value * 60
    this.expires = expires
    this.arrange()
    console.log("this.$route.query.enlistId",this.$route.query.enlistId)
    // this.getBaseData()
    this.getInfo()
  }
}
</script>

<style scoped>
>>> .ocr-info-title .ucar-section-title {
  font-weight: 550;
}

.photo-info {
  margin-top: 1.2rem;
}
</style>
